import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inscrip-page',
  templateUrl: './inscrip-page.component.html',
  styleUrls: ['./inscrip-page.component.css']
})
export class InscripPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
